import { useContext } from 'react';
import { AuthSessionContext } from '../contexts/authSessionContext';

/**
 * The Auth Session hook provides essential methods for managing different authentication methods needed for the app.
 * @See https://chalk.charter.com/display/ERSPM/FE+Auth+State+Pattern
 */
export const useAuthSession = () => {
  const {
    isAuthenticating,
    isAuthenticated,
    isAuthError,
    authToken,
    idToken,
    idTokenObj,
    legacyToken,
    showIdlePrompt,
    resetIdlePrompt,
    signOut,
  } = useContext(AuthSessionContext);
  return {
    isAuthenticating,
    isAuthenticated,
    isAuthError,
    authToken,
    idToken,
    idTokenObj,
    legacyToken,
    showIdlePrompt,
    resetIdlePrompt,
    signOut,
  };
};
